import React, { useContext, useEffect } from 'react';
import { Navigate, useRoutes } from 'react-router-dom';
// layouts
import DashboardLayout from './layouts/dashboard';
import LogoOnlyLayout from './layouts/LogoOnlyLayout';
//
import Login from './pages/Login';
import NotFound from './pages/Page404';
import Products from './pages/Products';
import ProductsLost from './pages/ProductsLost'
import Dashboard from './pages/Dashboard';
import Publier from './sections/@dashboard/publier/Publier';
import AuthContext from './contexts/AuthContext';
import Stockage from './sections/@dashboard/stockage/Stockage';
import AuthAPI from './service/authAPI';
import Messages from './pages/Messages';
import BoxDetail from "./sections/@dashboard/stockage/BoxDetail";
import Statistics from './pages/Statistics';
import { Settings } from './pages/Settings';
import Matching from './pages/Matching';
import MatchingChat from './sections/@dashboard/chat/MatchingChat';

// ----------------------------------------------------------------------

export default function Router() {
  const { isAuthenticated, setIsAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    setIsAuthenticated(AuthAPI.isAuthenticated());
  }, [setIsAuthenticated]);

  return useRoutes([
    {
      path: '/dashboard',
      element: isAuthenticated ? <DashboardLayout /> : <Navigate replace to="/login" />,
      children: [
        { index: true, element: <Dashboard /> },
        { path: 'app', element: <Publier /> },
        { path: 'messages', element: <Messages /> },
        { path: 'matching', element: isAuthenticated ? <Matching /> : <Navigate replace to="/login" /> },
        { path: 'matching/:id', element: isAuthenticated ? <Matching /> : <Navigate replace to="/login" /> },
        { path: 'matching/chat/:matchingId', element: isAuthenticated ? <MatchingChat /> : <Navigate replace to="/login" /> },
        { path: 'products/:annonceID', element: isAuthenticated ? <Products /> : <Navigate replace to="/login" /> },
        {
          path: 'products/trouves',
          element: isAuthenticated ? <Products status="TROUVÉ" /> : <Navigate replace to="/login" />,
        },
        {
          path: 'products/perdus',
          element: isAuthenticated ? <ProductsLost status="PERDU" /> : <Navigate replace to="/login" />,
        },
        {
          path: 'products/restitues',
          element: isAuthenticated ? <Products status="RESTITUÉ" /> : <Navigate replace to="/login" />,
        },
        {
          path: 'products/aexpedie',
          element: isAuthenticated ? <Products status="A_EXPEDIER" /> : <Navigate replace to="/login" />,
        },
        {
          path: 'products/payes',
          element: isAuthenticated ? <Products status="PAYÉ" /> : <Navigate replace to="/login" />,
        },
        {
          path: 'products/envoyes',
          element: isAuthenticated ? <Products status="ENVOYÉ" /> : <Navigate replace to="/login" />,
        },
        { path: 'stockage', element: <Stockage /> },
        { path: 'stockage/:id', element: <BoxDetail />},
        { path: 'publish', element: <Publier /> },
        { path: 'statistics', element: <Statistics /> },
        { path: 'settings', element: <Settings /> },
      ],
    },
    {
      path: '/',
      element: <LogoOnlyLayout />,
      children: [
        { path: '/', element: <Navigate to="/dashboard" /> },
        { path: 'login', element: <Login /> },
        { path: '404', element: <NotFound /> },
        { path: '*', element: <Navigate to="/404" /> },
      ],
    },
    { path: '*', element: <Navigate to="/404" replace /> },
  ]);
}